import { httpClient } from '@/services/http/httpClient'

type Params = {
  ideaId: string
  evaluationType: 'technical' | 'criteria'
  userIds: string[]
  message: string
}

export async function notifyEvaluation({
  ideaId,
  evaluationType,
  userIds,
  message,
}: Params) {
  await httpClient.post('/ideas/evaluations/notify', {
    ideaId,
    evaluationType,
    userIds,
    message,
  })
}
